import { render, staticRenderFns } from "./diagnostika.vue?vue&type=template&id=4b7d91e2&"
import script from "./diagnostika.vue?vue&type=script&lang=js&"
export * from "./diagnostika.vue?vue&type=script&lang=js&"
import style0 from "./diagnostika.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
